export default __webpack_public_path__ + "static/shib-2273a739c81d21120d5d9dde9f799926.png";